export interface ModuleDefinition {
  id: string;
  name: string;
  description: string;
  route: string;
}

export const MODULE_REGISTRY: ModuleDefinition[] = [
  {
    id: 'data-lab',
    name: 'Data Lab',
    description: 'Explore datasets, run experiments, and validate insights.',
    route: '/modules/data-lab',
  },
  {
    id: 'trading-lab',
    name: 'Trading Lab',
    description: 'Test strategies, simulate trades, and analyze performance.',
    route: '/modules/trading-lab',
  },
  {
    id: 'model-tuner',
    name: 'Model Tuner',
    description: 'Compare PJM actuals vs PCM outputs, diagnose mismatches, and iterate patch-based reruns.',
    route: '/modules/tuning',
  },
  {
    id: 'power-flow',
    name: 'Power Flow Analysis',
    description: 'Solve steady-state flows and voltage profiles.',
    route: '/modules/power-flow',
  },
  {
    id: 'contingency',
    name: 'Contingency Analysis',
    description: 'Evaluate N-1/N-2 outages and violations.',
    route: '/modules/contingency',
  },
  {
    id: 'market-sim',
    name: 'Market Simulation',
    description: 'Simulate bids, clearing, and price formation.',
    route: '/modules/market-sim',
  },
  {
    id: 'renewables',
    name: 'Renewables Integration',
    description: 'Assess variability, forecasts, and impacts.',
    route: '/modules/renewables',
  },
  {
    id: 'model-builder',
    name: 'Model Builder',
    description: 'Configure PCM models and solver settings.',
    route: '/modules/model-builder',
  },
  {
    id: 'constraint-map',
    name: 'PJM Constraint Map',
    description: 'Overlay ISO-published and PCM-forecasted binding constraints on the same map.',
    route: '/modules/constraint-map',
  },
];
